import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_INCOME_VERIFICATION_GET_BY_APPLICATION_ID,
} from 'api/actionTypes';

export default async function getByApplicationId(
  { state, apiClient },
  { householdApplicationId, reload, includeCurrentJobInfo },
) {
  typeCheck('householdApplicationId::PositiveNumber', householdApplicationId);

  const statePath = ['incomeVerifications', 'byApplicationId', householdApplicationId];

  if (!reload && state.get(statePath)) {
    return state.get(statePath);
  }

  const incomeVerification = await apiClient.postWithState({
    action: SR_API_ACTION_INCOME_VERIFICATION_GET_BY_APPLICATION_ID,
    state: state,
    payload: { householdApplicationId, includeCurrentJobInfo },
  });

  state.set(statePath, incomeVerification);

  return incomeVerification;
}
